import { getAuthAxiosBackend } from "../../helpers/axios"

class MartyrServices{

    get(id){
        return getAuthAxiosBackend().get('taskeen/martyrs/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('taskeen/martyrs', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('taskeen/martyrs/' + id)
    }
}

export default new MartyrServices()